import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { SpaceAction, SpaceUserRole } from '@interfaces/space-access-control.types';
import { SpaceRolePermissionService } from '@services/space-role.service';
/* Directive to conditionally render elements based on user's role and action permissions in a space
 * Usage:
 * <ng-container *spaceUserCanDo="mySpaceRole; action: 'record_create'">
 *   <!-- Content to render if the user has permission to create records -->
 * </ng-container>
 */
@Directive({ selector: '[spaceUserCanDo]', standalone: false })
export class SpaceUserActionDirective {
  private role!: SpaceUserRole | null | undefined;
  private action: SpaceAction | null = null;

  @Input() set spaceUserCanDo(role: SpaceUserRole | null | undefined) {
    this.role = role;
    this.render();
  }

  @Input() set spaceUserCanDoAction(action: SpaceAction | null | undefined) {
    this.action = action || null;
    this.render();
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private spacePermissionService: SpaceRolePermissionService,
  ) {}

  private render(): void {
    this.viewContainer.clear();
    if (this.role && this.action) {
      const isAllowed = this.spacePermissionService.checkSpaceUserPermission(this.role, this.action);

      if (isAllowed) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    }
  }
}
